<template>
  <div class="container" v-if="path.length">
    <div class="col-lg-12 d-flex justify-content-center mb-2 m-top" @click="redirectBanner(sorteado.url)">
        <img :src="sorteado.image" :alt="translateMain.subscribe" width="1012" height="124"/>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import { mapState } from 'pinia'
import translateMain from 'tradutors/menu'

export default defineComponent({
  name: 'BannerAssineHorizontal',
  props: ['path'],
  computed: {
    ...mapState(localeStore, ['locale']),
    translateMain: function () {
      if (this.locale === 'pt-br') {
        return translateMain.portugues
      } else {
        return translateMain.ingles
      }
    }
  },
  watch: {
    'path': function () {
      if (this.path.length)
        this.sorteado = this.numeroAleatorioAteN()
    }
  },
  data() {
    return {
      sorteado: { image: '', url: '' }
    }
  },
  created() {
    if (this.path.length)
      this.sorteado = this.numeroAleatorioAteN()
  },
  methods: {
    numeroAleatorioAteN() {
      const numeroSorteado = Math.floor(Math.random() * (this.path.length));
      return this.path[numeroSorteado]
    },
    redirectBanner(url){
      window.location.href = url;
    }
  }
})
</script>
<style scoped lang="css">
img {
  width: 1012px;
  height: 124px;
  cursor: pointer;
}

@media screen and (max-width: 992px) {
  img {
    width: 95%;
    cursor: pointer;
    object-fit: cover;
    height: auto;
  }
}
</style>
